// Stubs for registry entries during the staged migration.
//
// `toCode` and `fromAst` start as throwers because nothing reaches
// them yet — codegen and parser still dispatch via their own switch
// statements. Once codegen migrates to the registry, each entry's
// `toCode` is replaced with a real printer; once parser migrates,
// each `fromAst` is replaced with a real matcher.
//
// Throwing (rather than returning a sentinel) makes any premature
// dispatch fail loudly with the kind name in the message.

export function STUB_NOT_IMPLEMENTED(
  kind: string,
  fn: 'toCode' | 'fromAst',
): never {
  throw new Error(
    `registry: ${fn} not yet implemented for kind '${kind}'`,
  );
}
